// extracted by mini-css-extract-plugin
module.exports = {"universityPage":"style_universityPage__kqrE9","universityHeaderView":"style_universityHeaderView__2j3L8","universityBtnSection":"style_universityBtnSection__1CnGY"};